<template>
  <div class="fixed">
      <div class="fixed-item" @click="goHref('/car')"><img src="../assets/icon/car.svg" alt=""></div>
      <div class="fixed-item"><img src="../assets/icon/kefu.svg" alt=""><img src="../assets/icon/kefu.jpg" alt=""></div>
      <div class="fixed-item"><img src="../assets/icon/ma.svg" alt=""><img src="../assets/icon/gongzhonghao.png" alt=""></div>
      <div class="fixed-item"><img src="../assets/icon/phone.svg" alt=""><img src="../assets/icon/xiazai.png" alt=""></div>
      <div class="fixed-item" @click="goTop"><img src="../assets/icon/back-to-top.svg" alt=""></div>
    </div>
</template>

<script>
export default {
    name: 'Fixed',
    methods: {
        goHref(url) {
            this.$router.push(url)
        },
        goTop() {
            document.documentElement.scrollTop = 0
        }
    }
}
</script>

<style lang="less" scoped>
.fixed {
    border: 1px solid #EBEBEB;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: 660px;
    transform: translateY(-50%);
    z-index: 1;
    &-item {
      border-top: 1px solid #EBEBEB;
      width: 60px;
      text-align: center;
      padding-top: 23px;
      padding-bottom: 23px;
      background: #fff;
      cursor: pointer;
      position: relative;
      img {
        &:nth-child(1) {
          width: 28px;
          height: 28px;
        }
        &:nth-child(2) {
          display: none;
          position: absolute;
          right: 60px;
          top: 0;
          border: 1px solid #eee;
          width: 136px;
          height: auto;
        }
      }
      &:first-child {
          border-top: 0;
        }
        &:hover {
          img:nth-child(2) {
            display: block;
          }
        }
    }
  }
</style>